/**
 * top-bar — v0M9.5 (2026-07-24).
 *
 * Right-hand column of faction-scope buttons that sit BELOW the Speed
 * HUD (top-right, y offset ~64px). At v0M9 the only button is
 * "Knowledge" — opens the Knowledge modal. Room to grow: Diplomacy,
 * Espionage, Faction Overview, etc. would slot into this container as
 * additional buttons without needing a new HUD element per surface.
 *
 * The button is styled to match the speed HUD pills so the visual
 * language stays consistent.
 */

import { injectMenuStyles } from './menu-styles';

export interface TopBarCallbacks {
  onOpenKnowledge(): void;
}

export interface TopBarHandle {
  destroy(): void;
}

export function mountTopBar(root: HTMLElement, callbacks: TopBarCallbacks): TopBarHandle {
  injectMenuStyles();

  const container = document.createElement('div');
  // Positioned absolutely at top-right, below the speed HUD (which sits
  // at top: 16px, height ~36px including padding = 52px). We start at
  // top: 64px to leave breathing room.
  container.style.position = 'fixed';
  container.style.top = '64px';
  container.style.right = '16px';
  container.style.display = 'flex';
  container.style.gap = '6px';
  container.style.zIndex = '600';

  const knowledgeBtn = document.createElement('button');
  knowledgeBtn.className = 'su-speed-hud-btn';
  knowledgeBtn.textContent = 'Knowledge';
  knowledgeBtn.title = 'Open Knowledge Tree (K)';
  knowledgeBtn.style.minWidth = '92px';
  knowledgeBtn.addEventListener('click', () => callbacks.onOpenKnowledge());
  container.appendChild(knowledgeBtn);

  root.appendChild(container);

  return {
    destroy() {
      container.remove();
    },
  };
}
